<div *ngIf="!isMobile">
  <div>
    <div class="card-header">
      <div class="card-title base-cursor" fxFlex="">
        <mat-card-title
          class="upper bold text-overflow"
          [innerHTML]="card?.title"
        ></mat-card-title>
        <mat-card-subtitle class="upperCase text-overflow">{{
          card?.city?.name ?? ''
        }}</mat-card-subtitle>
      </div>
    </div>
  </div>
  <div class="img-div">
    <div
      *ngIf="
        card?.category == '3' &&
        checkIfDateIsCurrentOrFuture(card?.dateStart, card?.dateEnd)
      "
      id="event-schedule"
    >
      <div class="event-date-box date-font">
        <!-- DATE MOIS/JOURS -->
        <div *ngIf="checkIfDateIsCurrent(card?.dateStart, card?.dateEnd)">
          {{ 'currently' | translate }}
        </div>
        <div
          *ngIf="!checkIfDateIsCurrent(card?.dateStart, card?.dateEnd)"
          class="date-content"
        >
          <div *ngIf="checkIfDateIsInterval(card?.dateStart, card?.dateEnd)">
            <div style="margin-bottom: 10px">
              {{ formatDate(card?.dateStart, 'short') }}
            </div>
            <mat-divider></mat-divider>
            <div style="margin-top: 10px">
              {{ formatDate(card?.dateEnd, 'short') }}
            </div>
          </div>
          <div *ngIf="!checkIfDateIsInterval(card?.dateStart, card?.dateEnd)">
            <div>
              {{ formatDate(card?.dateStart, 'long') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <mat-grid-list cols="4" rowHeight="1:1">
      <!-- ? No images so we only load one unique ? -->
      <div *ngIf="imageMediaLength() === 0">
        <mat-grid-tile class="tile" [colspan]="4" [rowspan]="2">
          <img
            #img
            class="tile-img img-orientation link-cursor"
            [src]="getCurrentImage(card.category)"
            (error)="manageImageError(img)"
            alt="{{ img.description }}"
          />
        </mat-grid-tile>
      </div>
      <!-- ? Images exists so we loop on them. ? -->
      <div *ngIf="card.images && card.images.length > 0">
        <mat-grid-tile
          class="tile"
          *ngFor="let img of card.images.slice(0, 5); let i = index"
          [colspan]="setColSpanNumber(i)"
          [rowspan]="setRowSpanNumber(i)"
        >
          <img
            #img
            class="tile-img img-orientation link-cursor"
            [src]="getCurrentImage(card.category, img)"
            (error)="manageImageError(img)"
            alt="{{ img.description }}"
            (click)="openGallery(i)"
          />
        </mat-grid-tile>
      </div>
      <!-- ? Media exists so we loop on them. ? -->
      <div *ngIf="card.media && card.media.length > 0 && card.media.length < 6">
        <mat-grid-tile
          class="tile"
          *ngFor="
            let media of card.media.slice(0, 5 - card.images.length);
            let i = index
          "
          [colspan]="setColSpanNumber(i + card.images.length)"
          [rowspan]="setRowSpanNumber(i + card.images.length)"
        >
          <iframe
            #media
            class="tile-img img-orientation link-cursor"
            [src]="sanitizeVideoUrl(media.url)"
            [title]="media.name"
            (click)="openGallery(i + card.images.length)"
          ></iframe>
        </mat-grid-tile>
      </div>
      <!-- ?GRIDTILES? -->
      <button
        *ngIf="imageMediaLength() > 5"
        mat-mini-fab
        color="primary"
        class="gallery"
      >
        {{ imageMediaLength() }}
      </button>
    </mat-grid-list>

    <div class="img-footer">
      <div>
        <div *ngIf="canShowRating()" class="rating">
          <!-- Accessibility -->
          <span class="cdk-visually-hidden">rating : {{ rating }}</span>
          <!-- rating -->
          <button
            mat-icon-button
            *ngFor="let i of [1, 2, 3, 4, 5]"
            (click)="rateCard(card.id, i)"
            aria-label="Voter"
          >
            <mat-icon aria-hidden="true">{{
              i <= rating
                ? 'star'
                : rating > i - 1
                ? 'star_half'
                : 'star_outline'
            }}</mat-icon>
          </button>
          <div>{{ voteCount }} Votes</div>
        </div>

        <div fxFlex=""></div>
        <p class="communities">
          <span class="base-cursor" translate="">SuggestedBy</span>
          <span *ngFor="let source of sources; let ind = index">
            <a
              class="suggested-link"
              *ngIf="source.url"
              href="{{ source.url }}"
              [innerHTML]="source.name"
              target="_blank"
            ></a>
            <span
              class="base-cursor"
              *ngIf="!source.url"
              [innerHTML]="source.name"
            ></span>
            {{ ind + 1 < sources.length ? ',' : '' }}
          </span>
        </p>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isMobile">
  <div class="img-block-sp">
    <div fxFlex="" class="card-header-sp">
      <button
        mat-mini-fab
        color="primary"
        (click)="goBack()"
        aria-label="Retour à la carte"
      >
        <mat-icon aria-hidden="true">chevron_left</mat-icon>
      </button>
      <span class="title-img">
        <span
          *ngIf="title != undefined && title[0] != undefined"
          class="bold"
          >{{ title[0] | translate }}</span
        >
        <span *ngIf="title != undefined && title[1] != undefined">{{
          title[1] | translate
        }}</span>
      </span>
      <div class="sns-sp">
        <button
          *ngIf="shouldDisplayPrint()"
          mat-mini-fab
          color="warn"
          class="sns-button"
          (click)="goPrint(); sendUpGaEventPrint()"
          aria-label="Imprimer"
        >
          <mat-icon aria-hidden="true">print</mat-icon>
        </button>
        <a
          *ngIf="hasPdf()"
          mat-mini-fab
          class="sns-button"
          [href]="card.pathPdf"
          download
          color="warn"
          title="Télécharger PDF"
          (click)="sendUpGaEventPdf()"
        >
          <mat-icon aria-hidden="true">picture_as_pdf</mat-icon>
        </a>
        <a
          *ngIf="card.category == 1"
          mat-mini-fab
          class="sns-button"
          [href]="card.pathGpx"
          download
          color="warn"
          title="Télécharger GPX"
          (click)="sendUpGaEventGpx()"
        >
          <mat-icon aria-hidden="true">share_location</mat-icon>
        </a>
        <div (mouseleave)="sns_sub.hidden = true">
          <button
            mat-mini-fab
            color="warn"
            class="shadow-sp sns-button"
            (click)="
              sns_sub.hidden = !sns_sub.hidden; sendGenericShareGaEvent()
            "
            aria-label="Menu réseaux sociaux"
          >
            <mat-icon aria-hidden="true">share</mat-icon>
          </button>
          <div #sns_sub [hidden]="true" class="sns-sub-menu-sp">
            <a
              mat-mini-fab
              [href]="
                'https://twitter.com/intent/tweet?text=' +
                tweetText +
                '&hashtags=Mybalade' +
                '&url=' +
                shareUrl
              "
              target="_blank"
              (click)="sns_sub.hidden = true; sendShareGaEvent(1)"
              color="warn"
              title="Twitter"
            >
              <mat-icon svgIcon="twitter" aria-hidden="true"></mat-icon>
            </a>
            <a
              mat-mini-fab
              href="{{
                'https://www.facebook.com/dialog/share?app_id=' +
                  fbApiKey +
                  '&href=' +
                  shareUrl
              }}"
              target="_blank"
              (click)="sns_sub.hidden = true; sendShareGaEvent(0)"
              color="warn"
              title="Facebook"
            >
              <mat-icon svgIcon="facebook2" aria-hidden="true"></mat-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="card-content-sp">
      <div class="img-div-sp">
        <img
          #img_sp
          (click)="openGallery(current)"
          *ngIf="current < card.images.length && card.images.length > 0"
          class="img-sp"
          [src]="getCurrentImage(card.category, card.images[current])"
          (error)="manageImageError(img_sp)"
          alt="{{ card.images[current].description }}"
        />
        <iframe
          #media
          class="img-sp"
          [src]="iframeUrl"
          [title]="card.media[current - card.images.length].name"
          *ngIf="current >= card.images.length && card.media.length > 0"
        ></iframe>
        <img
          #img_sp
          *ngIf="imageMediaLength() === 0"
          class="img-sp"
          [src]="getCurrentImage(card.category)"
          (error)="manageImageError(img_sp)"
          alt="Placeholder"
        />
      </div>
      <button
        class="nav-img to-left"
        mat-icon-button
        color="warn"
        (click)="navBackward()"
        aria-label="Image précedente"
      >
        <mat-icon aria-hidden="true">chevron_left</mat-icon>
      </button>
      <button
        class="nav-img to-right"
        mat-icon-button
        color="warn"
        (click)="navForward()"
        aria-label="Image suivante"
      >
        <mat-icon aria-hidden="true">chevron_right</mat-icon>
      </button>
    </div>

    <div class="card-footer-sp">
      <!-- Accessibility -->
      <div *ngIf="canShowRating()">
        <span class="cdk-visually-hidden">rating : {{ rating }}</span>
        <!-- rating -->
        <mat-icon
          *ngFor="let i of [1, 2, 3, 4, 5]"
          (click)="rateCard(card.id, i)"
          aria-hidden="true"
          color="primary"
          >{{
            i < rating ? 'star' : rating > i - 1 ? 'star_half' : 'star_outline'
          }}</mat-icon
        >
        <div>{{ voteCount }} Votes</div>
      </div>

      <div>
        <div class="img-div-pos" *ngIf="imageMediaLength() > 0">
          {{ current + 1 }}/{{ imageMediaLength() }}
        </div>
      </div>
    </div>
    <div>
      <div fxFlex="" class="card-title">
        <mat-card-title class="bold" [innerHTML]="card?.title"></mat-card-title>
        <mat-card-subtitle>{{ card?.city?.name ?? '' }}</mat-card-subtitle>
      </div>
    </div>

    <div class="prop-div communities">
      <mat-divider></mat-divider>
      <span class="base-cursor" translate="">SuggestedBy</span>
      <span *ngFor="let source of sources; let ind = index">
        <a
          class="suggested-link"
          *ngIf="source.url"
          href="{{ source.url }}"
          [innerHTML]="source.name"
          target="_blank"
          [title]="source.name"
        ></a>
        <span
          class="base-cursor"
          *ngIf="!source.url"
          [innerHTML]="source.name"
        ></span>
        {{ ind + 1 < sources.length ? ',' : '' }}
      </span>
      <mat-divider></mat-divider>
    </div>
  </div>
</div>
